const PIXEL_ID = '2032586933980278'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Inyecta el código base oficial de Meta Pixel y dispara PageView.
 * Idempotente: solo se inicializa una vez.
 */
export function initPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b, v, n?: any, t?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement('script')
    t.async = true
    t.src = v
    ;(b.head || b.body || b.documentElement).appendChild(t)
  })(window, document, 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

type PixelParams = Record<string, string | number | boolean | undefined>

/** Dispara un evento estándar de Meta (PageView, Lead, InitiateCheckout, Contact, etc.). */
export function trackEvent(event: string, params?: PixelParams): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}

/** Dispara un evento personalizado de Meta. */
export function trackCustom(event: string, params?: PixelParams): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('trackCustom', event, params)
}
